import React from "react";
import "./page404.css";
import { Button } from "..";
import { Link } from "react-router-dom";

function Page404() {
  return (
    <div class="page404-container">
      <div className="page404-wrapper">
        <div className="page404-desc">
          <h2>صفحه‌ی موردنظر وجود ندارد.</h2>
          <p>
            می‌توانید به صفحه‌ی اصلی برگردید یا اگر مایلید اطلاعات بیشتری به دست
            آورید، با ما تماس بگیرید.
          </p>
          <div className="button-container">
            <a
              href="https://corp.map.ir/contact-us/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button secondary>تماس با ما</Button>
            </a>
            <Link to={"/"}>
              <Button>صفحه‌ی اصلی</Button>
            </Link>
          </div>
        </div>
        <div className="page404-bg"></div>
      </div>
    </div>
  );
}

export default Page404;
